import React from 'react';
import { CircleAlert, RefreshCw } from 'lucide-react';
import EmptyState from '../../../components/site/EmptyState';

/** Centered spinner for a panel that is loading for the first time. */
export const LoadingState = ({ label = 'Loading' }) => (
  <div className="pk-loading" style={{ minHeight: 220 }} role="status" aria-live="polite">
    <span className="pk-spinner" aria-hidden="true" />
    <span className="sr-only">{label}</span>
  </div>
);

/** A failed load with a Retry button. */
export const ErrorState = ({ title = "Couldn't load this", message, onRetry }) => (
  <EmptyState
    role="alert"
    icon={<CircleAlert />}
    title={title}
    text={message}
    actions={
      onRetry && (
        <button type="button" className="pk-btn pk-btn--secondary pk-btn--sm" onClick={onRetry}>
          <RefreshCw aria-hidden="true" />
          Retry
        </button>
      )
    }
  />
);
